import React from "react";
import { useFieldArray } from "react-hook-form";
import { Button } from "@sscs/ui";
import {
  DeleteForeverIcon as DeleteIcon,
  ArrowLongRightIcon as MappingIcon,
} from "@sscs/ui/icons";
import { ConfirmButton } from "Components";
import { OidcOrgRoleMapping } from "Types";
import GroupName from "../GroupName/GroupName";
import SelectRole from "../SelectOrgRole/SelectOrgRole";
import styles from "./orgRoleMappingFields.module.scss";

const EMPTY_MAPPING: OidcOrgRoleMapping = {
  org_role: "OrganizationAdmin",
  mapping: "",
};

const OrgRoleMappingFields = (): React.JSX.Element => {
  const { fields, append, remove } = useFieldArray({
    name: "org_role_mappings",
  });

  const controlledFields = fields.map((field) => ({ ...field }));

  const handleAddRow = (event: React.MouseEvent) => {
    event.preventDefault();
    append(EMPTY_MAPPING);
  };

  const handleRemoveRow = (rowIndex: number) => {
    remove(rowIndex);
  };

  return (
    <div className={styles["org-role-mapping"]}>
      <div>
        {controlledFields.map((orgRoleMapping, index) => (
          <div
            key={orgRoleMapping.id}
            className={styles["org-role-mapping-row"]}
          >
            <GroupName name={`org_role_mappings[${index}].mapping`} />
            <MappingIcon className={styles["arrow-icon"]} />
            <SelectRole
              name={`org_role_mappings[${index}].org_role`}
              readOnly={index === 0}
            />
            {index > 0 && (
              <ConfirmButton
                className={styles["delete-action"]}
                color="secondary"
                onClick={() => handleRemoveRow(index)}
                icon={<DeleteIcon />}
              >
                Delete row
              </ConfirmButton>
            )}
          </div>
        ))}
      </div>
      <div>
        <Button color="secondary" onClick={handleAddRow}>
          Add mapping
        </Button>
      </div>
    </div>
  );
};

export default OrgRoleMappingFields;
